import type { ShapeElement } from "@ai-teach/types";

interface ShapeRendererProps {
  element: Partial<ShapeElement>;
  isLiveMode?: boolean;
}

export function ShapeRenderer({ element }: ShapeRendererProps) {
  const fill = element.fill || "#000000";
  const stroke = element.stroke || "none";
  const strokeWidth = element.strokeWidth || 0;

  return (
    <svg
      className="w-full h-full"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      role="img"
      aria-label={element.shapeType}
      style={{
        overflow: "visible",
      }}
    >
      {element.shapeType === "rectangle" && (
        <rect
          x="0"
          y="0"
          width="100"
          height="100"
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      )}

      {element.shapeType === "circle" && (
        <circle cx="50" cy="50" r="50" fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
      )}

      {element.shapeType === "triangle" && (
        <polygon
          points="50,0 100,100 0,100"
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      )}

      {element.shapeType === "diamond" && (
        <polygon
          points="50,0 100,50 50,100 0,50"
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      )}

      {element.shapeType === "hexagon" && (
        <polygon
          points="25,0 75,0 100,50 75,100 25,100 0,50"
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      )}

      {element.shapeType === "star" && (
        <polygon
          points="50,0 61,35 98,35 68,57 79,91 50,70 21,91 32,57 2,35 39,35"
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      )}

      {element.shapeType === "heart" && (
        <path
          d="M50,30 C50,20 40,10 30,10 C20,10 10,20 10,30 C10,40 20,50 50,80 C80,50 90,40 90,30 C90,20 80,10 70,10 C60,10 50,20 50,30 Z"
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      )}

      {element.shapeType === "cross" && (
        <polygon
          points="35,0 65,0 65,35 100,35 100,65 65,65 65,100 35,100 35,65 0,65 0,35 35,35"
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      )}

      {element.shapeType === "sun" && (
        <g transform="translate(50, 50) scale(0.045, -0.045) translate(-1100, -1100)">
          <path
            d="M1076 2143 c-3 -16 -39 -130 -79 -254 l-73 -227 -233 175 c-129 96 -230 166 -227 156 15 -37 176 -551 176 -559 0 -5 -126 -8 -292 -7 -279 2 -292 2 -268 -15 60 -42 396 -285 405 -294 6 -6 5 -12 -5 -18 -8 -5 -106 -73 -218 -152 l-202 -143 290 -3 c159 -1 290 -4 290 -7 0 -7 -159 -495 -176 -537 -15 -42 -10 -47 20 -20 12 10 104 79 206 152 102 73 195 142 207 153 20 18 21 18 26 0 3 -10 35 -112 71 -228 36 -116 69 -226 74 -245 8 -33 14 -18 95 225 48 143 91 259 97 258 5 -2 111 -77 235 -168 125 -91 227 -165 228 -165 1 0 -37 118 -84 262 -47 145 -89 274 -94 287 l-7 24 288 -8 c178 -4 285 -3 279 2 -5 5 -103 78 -217 163 -115 84 -208 156 -208 160 0 4 6 10 13 13 7 2 107 73 221 156 l209 152 -292 -3 c-256 -3 -290 -1 -285 12 17 43 184 544 181 546 -1 2 -104 -69 -227 -158 -124 -88 -229 -162 -235 -164 -9 -4 -166 465 -165 494 0 23 -18 12 -24 -15z"
            fill={fill}
            stroke={stroke}
            strokeWidth={strokeWidth}
          />
        </g>
      )}

      {element.shapeType === "arrow" && (
        <polygon
          points="0,35 60,35 60,15 100,50 60,85 60,65 0,65"
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      )}

      {element.shapeType === "double-arrow" && (
        <polygon
          points="0,50 25,15 25,35 75,35 75,15 100,50 75,85 75,65 25,65 25,85"
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      )}

      {element.shapeType === "tunnel" && (
        <path
          d="M 0,100 L 0,30 Q 0,0 30,0 L 70,0 Q 100,0 100,30 L 100,100 Z"
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      )}
    </svg>
  );
}
